export default "__VITE_ASSET__CdliEklH__"